<!-- <app-subnav [pageType]="'iquanta-initiative'"></app-subnav> -->
<app-header [pageType]="'iquanta-initiative'"></app-header>

<div class="bannersmall2 middle">
    <img alt=""class="img-fluid">
    <div class="container">
        <div class="row">
            <div class="col-md-8">
                <div class="innerhero">
                    <h2>iQuanta - Village Adoption Initiative</h2>
                    <p>Indrajeet Singh - CEO iQuanta</p>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="about_info pt-md-3 pb-md-5">
    <div class="container">
        <div class="row d-flex justify-content-center">
            <div class="col-md-7 mb-4 ">
                <img alt=""src="https://media.iquanta.in/ui_images/public_portal_img/iquanta_initiative.jpeg" alt="">

            </div>

           

            <div class="col-md-6">
                <img alt=""src="https://media.iquanta.in/ui_images/public_portal_img/indrainia.jpg" alt="">
            </div>
            
            <div class="col-md-10">
                <div class="about_head text-center">

                  

                    <h3>iQuanta - Free Education Initiative</h3>

                    <iframe width="60%" height="400" src="https://player.vimeo.com/video/863484047" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    

                   
                    <p>Keeping in line with the mission to make education accessible to everyone, iQuanta launched the Free Education initiative in 2017. It all started when Indrajeet Singh, the CEO of iQuanta received a letter from Saurabh Kumar Ranjan highlighting the lack of basic education in the village of Shahpur and asked for his help. Much to Mr. Ranjan’s surprise, Mr. Singh took the next flight available to Shahpur. He went and adopted the village completely - taking care of free education for every child there. He even converted his own house into a school.</p>


                   
                </div>

                <div class="india-img1">
                    <img alt=""src="https://media.iquanta.in/ui_images/public_portal_img/in1.jpg" alt="">
                    <h5>Indrajeet Singh’s House in Bihar - turned into a school.</h5>
                </div>

                <div class="row iniHome">

                    <div class="col-md-12">
                        <p class="my-4">In the past  years, under the initiative - iQuanta has adopted two villages by providing free education to more than 1500 students. </p>
                    </div>
                    <div class="col-md-6">
                        <img alt=""src="https://media.iquanta.in/ui_images/public_portal_img/in2.jpg" alt="">
                    </div>
                    <div class="col-md-6">
                        <img alt=""src="https://media.iquanta.in/ui_images/public_portal_img/in3.jpg" alt="">
                    </div>
                    <div class="col-md-6">
                        <img alt=""src="https://media.iquanta.in/ui_images/public_portal_img/in4.jpg" alt="">
                    </div>
                    <div class="col-md-6">
                        <img alt=""src="https://media.iquanta.in/ui_images/public_portal_img/in5.jpg" alt="">
                    </div>

                    <div class="col-md-6">
                        <img alt=""src="https://media.iquanta.in/ui_images/public_portal_img/iquanta_initiative1.jpg">
                    </div>
                    <div class="col-md-6">
                        <img alt=""src="https://media.iquanta.in/ui_images/public_portal_img/iquanta_initiative2.jpg">
                    </div>
                    <div class="col-md-4">
                        <img alt=""src="https://media.iquanta.in/ui_images/public_portal_img/iquanta_initiative3.jpg">
                    </div>  
                    <div class="col-md-4">
                        <img alt=""src="https://media.iquanta.in/ui_images/public_portal_img/iquanta_initiative4.jpg">
                    </div>

                    <div class="col-md-4">
                        <img alt=""src="https://media.iquanta.in/ui_images/public_portal_img/iquanta_initiative5.jpg">
                    </div>

                    <div class="col-md-12 mb-4">
                        
                    <h3 style="font-size: 22px;">On students demand, Mr Singh danced on the stage on the beats of Dhoom</h3>
                    <iframe width="100%" height="400" src="https://www.youtube.com/embed/gqhClAzenRY" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> 

                    </div>
                   
                </div>
                

                <div class="about_head text-center">
                    <h3>Village Adoption- 2017</h3>
                    <p>The results have been astounding to say the least. From 25 to more than 500 students with 4 full time teachers, the initiative has unearthed dozens of tremendous talent. </p>
                    <p>The initiative conducted a Rural Talent Search Examination in 118 villages and selected the top 5 students from each of them to provide free education.</p>
                </div>

                <div class="india-img1">
                    <img alt=""src="https://media.iquanta.in/ui_images/public_portal_img/in7.jpg" alt="">
                </div>

                <div class="row iniHome">

                    <div class="col-md-4">
                        <img alt=""class="mt-3" src="https://media.iquanta.in/ui_images/public_portal_img/in8.jpg" alt="">
                    </div>
                    <div class="col-md-4">
                        <img alt=""class="mt-3" src="https://media.iquanta.in/ui_images/public_portal_img/in9.jpg" alt="">
                    </div>
                    <div class="col-md-4">
                        <img alt=""class="mt-3" src="https://media.iquanta.in/ui_images/public_portal_img/in10.jpg" alt="">
                    </div>
                   
                </div>


                <div class="about_head text-center">

                    <div class="row">
                        <div class="col-md-6">
                            <iframe width="100%" height="400px" src="https://www.youtube.com/embed/GDGTzUdOze4?rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>

                        <div class="col-md-6">
                            <iframe width="100%" height="400px" src="https://www.youtube.com/embed/6n2UMERNGAY?rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>

                    <h3>Rural Talent Search Examination </h3>
                    <p>Ankush Kumar, one of the student selected under the initiative secured a 23rd Rank in BHU-SET entrance test. He is from a village without a single school in it. There are a lot of brilliant students like him who only ask for a chance to learn. The initiative gave him a scholarship which made it possible for him to get that opportunity.</p>
                </div>

                <div class="india-img1">
                    <img alt=""src="https://media.iquanta.in/ui_images/public_portal_img/in11.jpg" alt="">
                </div>

                <div class="row iniHome">

                    <div class="col-md-4">
                        <img alt=""class="mt-3" src="https://media.iquanta.in/ui_images/public_portal_img/in12.jpg" alt="">
                    </div>
                    <div class="col-md-4">
                        <img alt=""class="mt-3" src="https://media.iquanta.in/ui_images/public_portal_img/in13.jpg" alt="">
                    </div>
                    <div class="col-md-4">
                        <img alt=""class="mt-3" src="https://media.iquanta.in/ui_images/public_portal_img/in14.jpg" alt="">
                    </div>

                    <div class="col-md-12">

                    </div>

                    <div class="col-md-12">
                        <p>Moments of Appreciation from the people of Shahpur </p>
                        <p>The love and response that the initiative has received has been overwhelming. </p>

                        <p>Mr. Singh plans to adopt more than a 100 villages and provide free education to more than 15,000 students in the next two years. He has set up iQuanta Charitable Trust to achieve his  dream of education for all. </p>

                    </div>

                    <div class="col-md-12">
                        <img alt=""class="mt-3" src="https://media.iquanta.in/ui_images/public_portal_img/in15.jpg" alt="">

                        <p>Ceremony Hosted by the village of Shahpur</p>

                        <img alt=""class="mt-3" src="https://media.iquanta.in/ui_images/public_portal_img/in16.jpg" alt="">
                        <img alt=""class="mt-3" src="https://media.iquanta.in/ui_images/public_portal_img/in17.jpg" alt="">
                        <p>Some moments from the life of the students under the initiative </p>

                    </div>
                   
                </div>

            </div>
        </div>
    </div>
</div>



<app-footer></app-footer>